import { useAlertDialog } from "@overmap-ai/blocks"
import { memo, useEffect } from "react"

import { setAlertDialogOpener } from "../../utils/alertDialog"

/**
 * Publishes the alert dialog to non-React callers. Renders nothing; must be mounted inside `AlertDialogProvider`.
 */
export const AlertDialogBridge = memo(() => {
	const openAlertDialog = useAlertDialog()

	useEffect(() => {
		setAlertDialogOpener(openAlertDialog)
		return () => setAlertDialogOpener(undefined)
	}, [openAlertDialog])

	return null
})

AlertDialogBridge.displayName = "AlertDialogBridge"
